import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
const names = ['Marina L.', 'Federico G.', 'Julieta R.', 'Sofía M.', 'Martín P.', 'Camila B.', 'Lucas D.', 'Valentina S.', 'Tomás A.', 'Agustina F.', 'Nicolás V.', 'Florencia C.', 'Mateo R.', 'Carla T.', 'Joaquín N.', 'Brenda O.'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta', 'Santa Fe', 'Neuquén', 'Bariloche', 'Resistencia', 'Posadas', 'Bahía Blanca'];
const offers = ['el Plan Standard', 'el Pack Completo'];
interface ProofData {
  name: string;
  city: string;
  offer: string;
  minutesAgo: number;
}
function randomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function makeProof(): ProofData {
  return {
    name: randomItem(names),
    city: randomItem(cities),
    offer: randomItem(offers),
    minutesAgo: Math.floor(Math.random() * 9) + 1
  };
}
export function SocialProofPopup() {
  const [proof, setProof] = useState<ProofData | null>(null);
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;
    let nextTimer: ReturnType<typeof setTimeout>;
    const showOne = () => {
      setProof(makeProof());
      // Visible for 6 seconds
      hideTimer = setTimeout(() => {
        setProof(null);
        // Re-appear in 20–30 seconds
        const delay = 20000 + Math.random() * 10000;
        nextTimer = setTimeout(showOne, delay);
      }, 6000);
    };
    // First popup after a short initial delay
    const initial = setTimeout(showOne, 5000);
    return () => {
      clearTimeout(initial);
      clearTimeout(hideTimer);
      clearTimeout(nextTimer);
    };
  }, []);
  return <div className="fixed bottom-4 left-4 z-50 max-w-[calc(100vw-2rem)] sm:max-w-sm pointer-events-none" role="status" aria-live="polite" data-id="element-335">
      <AnimatePresence data-id="element-336">
        {proof && <motion.div key={`${proof.name}-${proof.minutesAgo}`} initial={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        duration: 0.3
      }} className="pointer-events-auto bg-offwhite border border-brown/10 rounded-2xl shadow-lg p-3 md:p-4 flex items-start gap-3" data-id="element-337">
            <div className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-sage/15 flex items-center justify-center shrink-0" data-id="element-338">
              <CheckCircle2 size={20} className="text-sage" data-id="element-339" />
            </div>

            <div className="min-w-0 pr-4" data-id="element-340">
              <div className="flex items-center gap-1.5 mb-0.5" data-id="element-341">
                <span className="font-sans font-bold text-[11px] md:text-xs uppercase tracking-wide text-sage" data-id="element-342">
                  Compra verificada
                </span>
              </div>
              <p className="font-sans text-xs md:text-sm text-brown leading-snug" data-id="element-343">
                <span className="font-bold" data-id="element-344">{proof.name}</span> de{' '}
                <span className="font-bold" data-id="element-345">{proof.city}</span> compró{' '}
                {proof.offer}.
              </p>
              <p className="font-sans text-[10px] md:text-xs text-brown/50 mt-0.5" data-id="element-346">
                hace {proof.minutesAgo}{' '}
                {proof.minutesAgo === 1 ? 'minuto' : 'minutos'}
              </p>
            </div>

            <button type="button" onClick={() => setProof(null)} aria-label="Cerrar aviso" className="absolute top-2 right-2 text-brown/40 hover:text-brown transition-colors" data-id="element-347">
              <X size={16} data-id="element-348" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}